import React from "react";
import { Link } from "react-router-dom";
import type { Product } from "../../hooks/products/types";

type BannerTwoProps = {
  products?: Product[];
  product?: Product;
};

const containerClass =
  "relative rounded-2xl overflow-hidden min-h-[250px] sm:min-h-[300px] md:min-h-[350px]";

const BannerTwo: React.FC<BannerTwoProps> = ({
  products = [],
  product: singleProduct,
}) => {
  const getProduct = (index: number) => {
    if (products && products.length > index) return products[index];
    if (index === 0 && singleProduct) return singleProduct;
    return undefined;
  };

  const product1 = getProduct(0);
  const product2 = getProduct(1);

  return (
    <div className="w-full pt-4 sm:pt-6 md:pt-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <div className="lg:col-span-1">
            {product1 ? (
              <div className={containerClass}>
                <img
                  src={product1.image || ""}
                  alt={product1.name}
                  className="w-full h-62.5 sm:h-75 md:h-87.5 object-cover"
                />
                <div className="absolute inset-0 bg-black/30"></div>
                <div className="absolute inset-0 w-full h-full flex items-center justify-center z-10 p-4">
                  <div className="text-center max-w-xs sm:max-w-sm">
                    <h2 className="text-white font-bold text-xl sm:text-2xl md:text-3xl mb-2 sm:mb-4">
                      {product1.name}
                    </h2>
                    <p className="text-white text-sm sm:text-base md:text-lg mb-4 sm:mb-6 line-clamp-2">
                      {product1.description}
                    </p>
                    <Link
                      to={`/product/${product1.id}`}
                      className="inline-block border border-white text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg hover:bg-white hover:text-primary-600 transition-colors text-sm sm:text-base"
                    >
                      Shop Collection
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <div className="relative rounded-2xl overflow-hidden min-h-62.5 sm:min-h-75 md:min-h-87.5 bg-section-skeleton animate-pulse">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="h-8 bg-white/20 rounded w-1/2"></div>
                </div>
              </div>
            )}
          </div>
          <div className="lg:col-span-1">
            {product2 ? (
              <div className="relative rounded-2xl overflow-hidden min-h-62.5 sm:min-h-75 md:min-h-87.5">
                <img
                  src={product2.image || ""}
                  alt={product2.name}
                  className="w-full h-62.5 sm:h-75 md:h-87.5 object-cover"
                />
                <div className="absolute inset-0 bg-black/30"></div>
                <div className="absolute inset-0 w-full h-full flex items-center justify-center z-10 p-4">
                  <div className="text-center max-w-xs sm:max-w-sm">
                    <h2 className="text-white font-bold text-xl sm:text-2xl md:text-3xl mb-2 sm:mb-4">
                      {product2.name}
                    </h2>
                    <p className="text-white text-sm sm:text-base md:text-lg mb-4 sm:mb-6 line-clamp-2">
                      {product2.description}
                    </p>
                    <Link
                      to={`/product/${product2.id}`}
                      className="inline-block border border-white text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg hover:bg-white hover:text-primary-600 transition-colors text-sm sm:text-base"
                    >
                      Shop Now
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <div className="relative rounded-2xl overflow-hidden min-h-62.5 sm:min-h-75 md:min-h-87.5 bg-section-skeleton animate-pulse">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="h-8 bg-white/20 rounded w-1/2"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerTwo;
